import { providerApi } from '@/api/ProviderApi'
import type { AppointmentResultReportResponse } from '@/api/types/ProviderApi'
import { useQuery } from '@tanstack/react-query'
import { isNil } from 'ramda'

export const useFetchLatestAppoinmentResults = () => {
	const { data, isLoading: isLoadingResults } = useQuery({
		queryKey: ['latest-patient-appointment-results'],
		queryFn: () => providerApi.fetchLatestAppointmentResults(),
		staleTime: 1000 * 60 * 2, // 2 minutes
	})

	const results = data ?? ({} as AppointmentResultReportResponse)

	return {
		appointmentResults: results.results,
		hasLockedResults: results.isLocked,
		appointmentId: results.appointmentId,
		isLoadingResults,
		hasAppointmentResults: !isLoadingResults && !isNil(results.results),
		/** The read itself failed, as opposed to there being nothing to show yet. */
		isUnavailable: !isLoadingResults && data === null,
	}
}
